<template>
<div>
            <div class="head01"
                style="z-index: 99; color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(255, 255, 255, 0.8); width: 1903px; height: 87px; font-size: 12px; line-height: 18px; margin: 0px; padding: 0px; position: fixed; float: none; inset: 0px 0px 850px; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;">
                <div class="g-in clearfix"
                    style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 1200px; height: 87px; font-size: 12px; line-height: 18px; margin: 0px 351.5px; padding: 0px; position: static; float: none; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;">
                    <div class="logo"
                        style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 385px; height: 87px; font-size: 12px; line-height: 30px; margin: 0px; padding-top: 25px; position: static; float: left; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;">
                        <a href="#"
                            style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: auto; height: auto; font-size: 12px; line-height: 30px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: inline; border: 0px none rgb(102, 102, 102); cursor: pointer; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;"><img
                                src="../assets/upload/logo/logo.png"
                                alt="新疆清源天诚环保科技有限公司"
                                style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);  height: 30px; font-size: 12px; line-height: 30px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: flex; border: 0px none rgb(102, 102, 102); cursor: pointer; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;"></a>
                    </div>
                    <div class="nav"
                        style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 656px; height: 86px; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: right; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none disc; text-align: start;">
                        <ul class="headList"
                            style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 750px; height: 86px; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: start;">
                            <li
                                style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 28px; height: 86px; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px 14px; position: relative; float: left; inset: 0px; display: list-item; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: left;">
                                <a href="#" class="shouye">首页</a>
                            </li>
                            <li v-for="(item,index) in type" :key="index"  @mouseenter="typeMouseMove(item)" @mouseleave="typeMouseOut(item)" 
                            class=""
                                style="color: rgb(102, 102, 102); background: url(&quot;http://www.rinland.cn/images/nav01.png&quot;) 0% 50% / auto no-repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: 56px; height: 86px; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px 14px 0px 16px; position: relative; float: left; inset: 0px; display: list-item; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: left;">
                                <a>{{item.name}}</a>
                                <div class="subNav"
                                    style="color: rgb(102, 102, 102);display: block; background: none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255); width: 140px; height: auto; font-size: 14px; line-height: 18px; margin: 0px 0px 0px -70px; padding: 0px; position: absolute; float: none; inset: 86px auto auto 50%; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: left;">
                                    <dl
                                        style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: auto; height: auto; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: left;">
                                        <dt v-for="(item,index) in item.types " :key="index" v-show="item.typesFlag"
                                            style="color: rgb(102, 102, 102); background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0); width: auto; height: auto; font-size: 14px; line-height: 18px; margin: 0px; padding: 0px; position: static; float: none; inset: auto; display: block; border: 0px none rgb(102, 102, 102); cursor: auto; overflow: visible; box-sizing: content-box; border-radius: 0px; text-decoration: none solid rgb(102, 102, 102); list-style: outside none none; text-align: left;">
                                           <a>{{item.name}}</a>
                                        </dt>
                                    </dl>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
        </div>
</div>
</template>

<script>
export default {
  name: 'test',
  data(){
    return{
      type:[
      {
        name:'智慧水利',
        types:[
          {
            name:'智慧水务',
            typesFlag :false,
          },
          {
            name:'城乡供水一体化',
            typesFlag :false,
          },
          {
            name:'大中型灌区信息化建设',
            typesFlag :false,
          },
          {
            name:'山洪灾害防治非工程措施',
            typesFlag :false,
          },
          {
            name:'水库大坝安全监测自动化系统',
            typesFlag :false,
          },
          ]
      },
      {
        name:'智慧农业',
        types:[
          {
            name:'土壤墒情',
            typesFlag :false,
          },
          {
            name:'智能首部',
            typesFlag :false,
          },
          {
            name:'田间灌溉',
            typesFlag :false,
          },
          {
            name:'四情监控',
            typesFlag :false,
          }
        ]
      },
      {
        name:'产品中心',
        types:[
          {
            name:'首部过滤器',
            typesFlag :false,
          },
          {
            name:'智能施肥机',
            typesFlag :false,
          },
          {
            name:'智能监控变频柜',
            typesFlag :false
          },
          {
            name:'太阳能供电设备',
            typesFlag :false
          },
          {
            name:'明渠计量设备',
            typesFlag :false,
          },
          {
            name:'智能测控闸阀',
            typesFlag :false,
          },
          {
            name:'智慧农业设备',
            typesFlag :false,
          }
        ]
      },
      {
        name:'项目案例',
        types:[
          
        ]
      },
      {
        name:'技术支持',
        types:[
          {
            name:'过滤器选型',
            typesFlag :false,
          },
          {
            name:'太阳能供电选型',
            typesFlag :false,
          },
          {
            name:'视频监控选型',
            typesFlag :false,
          }
        ]
      },
      {
        name:'企业动态',
        types:[]
      },
      {
        name:'关于清源天诚',
        types:[]
      }
      ]
    }
  },
  props: {
    msg: String
  },
  methods:{
    typeMouseMove(num){
     for (var i = 0 ;i < num.types.length  ;i++){
       num.types[i].typesFlag = true
     }
    },
    typeMouseOut(num){
     for (var i = 0 ;i < num.types.length  ;i++){
       num.types[i].typesFlag = false
     }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.onon {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255);
    width: 14px;
    height: 14px;
    font-size: 12px;
    line-height: 999px;
    margin: 0px 4px;
    padding: 0px;
    position: static;
    float: none;
    inset: auto;
    display: inline-block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: hidden;
    box-sizing: content-box;
    border-radius: 100%;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: center;

}

.on {
    color: rgb(0, 160, 234);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgb(0, 160, 234);
    width: 14px;
    height: 14px;
    font-size: 12px;
    line-height: 999px;
    margin: 0px 4px;
    padding: 0px;
    position: static;
    float: none;
    inset: auto;
    display: inline-block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: hidden;
    box-sizing: content-box;
    border-radius: 100%;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: center;

}

.headList>li>a {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);
    width: 84px;
    height: 86px;
    font-size: 14px;
    line-height: 86px;
    margin: 0px;
    padding: 0px;
    position: static;
    float: none;
    inset: auto;
    display: block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: visible;
    box-sizing: content-box;
    border-radius: 0px;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: left;
}

.headList>li>a:hover {
    color: rgb(0, 160, 234)
}

.headList>li>div>dl>dt>a {
    color: rgb(102, 102, 102);
    background: none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0);
    width: 100%;
    height: auto;
    font-size: 12px;
    line-height: 18px;
    margin: 0px;
    padding: 7px 3px;
    position: static;
    float: none;
    inset: auto;
    display: block;
    border: 0px none rgb(102, 102, 102);
    cursor: pointer;
    overflow: visible;
    box-sizing: border-box;
    border-radius: 0px;
    text-decoration: none solid rgb(102, 102, 102);
    list-style: outside none none;
    text-align: center;
}
.headList>li>div>dl>dt>a:hover{
    color: #ffffff;
    background-color: rgb(0, 160, 234);
}
</style>
